import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import AddCourseComp from './AddCourseComp'

function AddCourse() {
  return (
    <div>
      <div className='mainContainer'>
        <Leftmenu />
        <div className='theMainContainer'>
          <Dashnav />
          <AdmissionTopNotice />
          <AddCourseComp />
        </div>
      </div>
    </div>
  )
}

export default AddCourse
